import React, { useState } from "react";
import { makeStyles } from "@material-ui/core";
import { highlightColorRGBA } from "./HighlightColor";
import { RadioButton } from "../FormElements";
import useReactiveFunctionWithDebouncing from "./useReactiveFunctionWithDebouncing";

const useStyles = makeStyles((theme) => ({
  highlighted: {
    backgroundColor: highlightColorRGBA + ' !important', // !important pro hover não sobrescrever
  }
}));

export default function HighlightableRadio({ isHighlightedFunction, safeToHighlight = true, className, ...props }) {
  const { id: value } = props; // essa do id foi osso, jeez
  const [highlighted, setHighlighted] = useState(isHighlightedFunction(value));
  const classes = useStyles();
  
  useReactiveFunctionWithDebouncing({
                              functionn: isHighlightedFunction,
                              reactiveArgument: value,
                              safeToRun: safeToHighlight,
                              setReturnedValue: setHighlighted,
                              noDebouncing: true
                            });
  
  
  return (
    <RadioButton {...props} className={`${className ?? ''} ${highlighted ? classes.highlighted : ''}`}/>
  );
}
